<template>
  <div class="page-wrapper">
    <Tabs  v-model="current" :animated="false">
      <TabPane name="1" label="排班" v-if="p('business/getSchedule/list')">
        <pai-ban></pai-ban>
      </TabPane>
      <TabPane name="2" label="班次管理" v-if="p('business/getScheduleConfig/list')">
        <schedule-config></schedule-config>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
  import paiBan from'./paiban/index'  ;
  import scheduleConfig from './scheduleConfig/index'
  import {mixin} from "../../../mixin";

  export default {
    name:'schedule',
    mixins:[mixin],
    components:{
      paiBan,
      scheduleConfig
    }        ,
    data(){
      return {
        current:null
      }
    }

  }
</script>

<style scoped>

</style>
